import React, { useEffect } from 'react'
import Navbar from '../Homepage/Navbar/Navbar'
import Banner from './Banner/Banner'
import Market from './Market/Market'
import Storm from './Storm/Storm'
import Footer from '../Homepage/footer/Footer'
import { useTheme } from '../../contexts/ThemeProvider'
import SEO from '../SEO'

const Apps = () => {
  const { theme, toggle } = useTheme();

  useEffect(() => {
    if (theme !== "dark") {
      toggle();
    }
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  useEffect(() => {
    document.body.classList.add("home-page-body");
    return () => {
      document.body.classList.remove("home-page-body");
    };
  }, []);
  return (
    <>
      <SEO
        url='https://www.rain.one/apps'
      />
      <Navbar />
      <Banner />
      <Market />
      <Storm />
      <Footer />
    </>
  )
}

export default Apps
